import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const DJTypeChart: React.FunctionComponent = (props) => {
    const [total, setTotal] = React.useState(0)
    return (
        <BPMChart {...props} title='DJ Type' type='pie' subTitle={`Total of ${total} downloads`}
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('downloads/dj-type', options, signal).then((d) => {
                    setTotal(d.reduce((a, b) => a + b.count, 0))
                    return d
                })
            }} additionalParams={{ groupBy: 'dj_type' }}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Downloads', valueField: 'count', argumentField: 'dj_type'
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/DJTypeChart.tsx